module.exports = __webpack_public_path__ + "assets/adas-card-image.83d68d33.svg";